"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NewClassConfigurationDialogModule = /** @class */ (function () {
    function NewClassConfigurationDialogModule() {
    }
    return NewClassConfigurationDialogModule;
}());
exports.NewClassConfigurationDialogModule = NewClassConfigurationDialogModule;
